import React from 'react';

interface IconProps {
  color?: string;
}

const GeneralDocumentBannerIcon: React.FC<IconProps> = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 350 480"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M81.3619 192.49 259.961 192.49"
          stroke="black"
          stroke-width="11.9066"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <path
          d="M81.3619 255.992 259.961 255.992"
          stroke="black"
          stroke-width="11.9066"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <path
          d="M81.3619 319.494 197.782 319.494"
          stroke="black"
          stroke-width="11.9066"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <path
          d="M5.95331 465.02 5.95331 111.79 111.79 5.95331 334.047 5.95331 334.047 465.02 5.95331 465.02Z"
          stroke="black"
          stroke-width="11.9066"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <path
          d="M111.79 111.79 5.95331 111.79 111.79 5.95331 111.79 111.79Z"
          stroke="black"
          stroke-width="11.9066"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
      </g>
    </svg>
  );
};

export default GeneralDocumentBannerIcon;
